'use client';

import { DocumentNode, print } from 'graphql';
import {
  DEFAULT_IMAGE,
  HEADER_KEY_CLIENT,
  HEADER_VAL_CLIENT,
  SERVER_API_DEV_GQL,
  SERVER_API_PRO_GQL,
  SERVER_HOST_DEV,
  SERVER_HOST_PRO,
} from './constant';
import { Dispatch, SetStateAction } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { IPictureUpload } from './interface/general.interface';
import { IUploadState } from '@/lib/interface/dropzone.type';

export const serverGateway = async (GQLDN: DocumentNode, variables: any) => {
  let uri: string;

  switch (process.env.NODE_ENV) {
    case 'development':
      uri = SERVER_API_DEV_GQL;
      break;
    case 'production':
      uri = SERVER_API_PRO_GQL;
      break;
    default:
      uri = SERVER_API_PRO_GQL;
  }

  try {
    const rs: any = await (
      await fetch(uri, {
        method: 'POST',
        cache: 'no-store',
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          [HEADER_KEY_CLIENT]: HEADER_VAL_CLIENT,
        },
        body: JSON.stringify({ query: print(GQLDN), variables }),
      })
    )?.json();

    if (rs.data) return rs.data;
    else if (rs.errors?.length) {
      console.log('GQL Errors =======> ');

      for (let i = 0; i < rs.errors; i++) {
        console.log(rs.errors[i]);
      }
    }
  } catch (error) {
    console.log('SAPI Error =======> ', error);
  }
};
let NONE = "none" //// none keyword is a fallback for avatars to display the first character of alt in images
export const sourceImage = (filenameOrId?: string) => {
  if (!filenameOrId) {
    return NONE
    // return `/img/${DEFAULT_IMAGE}`;
  }

  const host = process.env.NODE_ENV === 'development' ? SERVER_HOST_DEV : SERVER_HOST_PRO;
  return `${host}/document/f/${filenameOrId}`;
};

export const uploadPhoto = async (
  base64Data: string | null | undefined,
  setPhoto: Dispatch<SetStateAction<IPictureUpload>>,
  reference?: string,
): Promise<void> => {
  if (!base64Data) return;

  const blob = await (await fetch(base64Data)).blob();
  const file = new File([blob], 'outputFileName.jpg', { type: 'image/jpeg' });

  setPhoto({ loading: true });

  const config: AxiosRequestConfig = {
    headers: {
      [HEADER_KEY_CLIENT]: HEADER_VAL_CLIENT,
    },
  };

  let formData = new FormData();

  formData.append('file', file);

  try {
    let url: string;

    switch (process.env.NODE_ENV) {
      case 'development':
        url = `${SERVER_HOST_DEV}/document/u-local`;
        break;
      case 'production':
        url = `${SERVER_HOST_PRO}/document/u-space`;
        break;
      default:
        url = `${SERVER_HOST_PRO}/document/u-space`;
    }

    const data = (await axios.post(url, formData, config))?.data;

    setPhoto({ loading: false, id: data.id, fileName: data.fileName || data.filename, reference });
  } catch (error) {
    console.log('~~~~~~~~~~~~~ PICTURE UPLOAD ERROR ~~~~~~~~~~~~~');
    console.log(error);

    setPhoto({ loading: false });
  }
};

export const uploadFile = async (file: File, state: IUploadState, onStateChange: (currentState: IUploadState) => void) => {
  const config: AxiosRequestConfig = {
    headers: { [HEADER_KEY_CLIENT]: HEADER_VAL_CLIENT },
    onUploadProgress: function (event: any) {
      const progress = Math.round((event.loaded * 100) / event.total);
      onStateChange({ ...state, progress, uploaded: event.loaded });
    },
  };

  let formData = new FormData();
  formData.append('file', file);

  try {
    let url: string;
    switch (process.env.NODE_ENV) {
      case 'development': url = `${SERVER_HOST_DEV}/document/u-local`; break;
      case 'production': url = `${SERVER_HOST_PRO}/document/u-space`; break;
      default: url = `${SERVER_HOST_PRO}/document/u-space`;
    }
    return (await axios.post(url, formData, config))?.data;
  } catch (error) {
    console.log('~~~~~~~~~~~~~ FILE UPLOAD ERROR ~~~~~~~~~~~~~', error);
  }
}
